import moment from 'moment';

export const COOKIE_NAME_EMAIL_MARKETING_COUNTDOWN =
  'hideEmailMarketingCountdown';

export const EMAIL_MARKETING_TRIAL_DATE_EXPIRED = 'Expired';

export const CAMPAIGNS_PAGE_SIZE = 10;

export const CAMPAIGN_STATUS_ALL = 'all';

export const CAMPAIGN_STATUS_OPTIONS = [
  {value: CAMPAIGN_STATUS_ALL, label: 'All'},
  {value: 'active', label: 'Active'},
  {value: 'completed', label: 'Completed'}
];

export const CAMPAIGN_STATUS_LABELS = {
  active: 'Active',
  completed: 'Completed',
  draft: 'Paused'
};

export const CAMPAIGN_SUBJECT_FALLBACK = 'Untitled campaign';

export const campaignTitle = (campaign) =>
  campaign?.subject || campaign?.name || CAMPAIGN_SUBJECT_FALLBACK;

/** `typeLabel` from the list endpoint holds raw Customer.io values like
 * `seg_attr`, so the label comes from sourceType instead. */
export const campaignTypeLabel = (campaign) =>
  campaign?.sourceType === 'campaign' ? 'Automated' : 'Single Send';

export const campaignStatusLabel = (campaign) =>
  CAMPAIGN_STATUS_LABELS[campaign?.statusLabel] || '';

export const EMPTY_VALUE = '-';

export const formatCount = (value) =>
  new Intl.NumberFormat('en-GB', {maximumFractionDigits: 0}).format(value || 0);

export const formatRate = (value) =>
  value === null || value === undefined
    ? EMPTY_VALUE
    : `${(value * 100).toFixed(2)}%`;

export const formatRateShort = (value) =>
  value === null || value === undefined
    ? EMPTY_VALUE
    : `${(value * 100).toFixed(1)}%`;

export const formatCampaignDate = (value) =>
  value ? moment(value).format('MMM D, YYYY') : EMPTY_VALUE;

export const CAMPAIGN_PREVIEW_ERROR = {
  title: 'We could not load the email preview',
  description: 'Please try again in a moment.'
};

export const CAMPAIGN_PREVIEW_UNAVAILABLE = {
  title: 'Email preview is not available yet',
  description:
    'It may appear here later. If you need help, please reach out to our team.'
};
